<mat-toolbar>
  <h1>Dashboard</h1>
</mat-toolbar>

<mat-accordion [multi]="true">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Due Invoices</mat-panel-title>
      <mat-panel-description> Payments due in the next 14 days </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        mat-mini-fab
        color="primary"
        matTooltip="View more"
        matTooltipPosition="left"
        [routerLink]="['/app/retained']"
      >
        <mat-icon>query_stats</mat-icon>
      </button>

      <button
        mat-mini-fab
        matTooltip="Refresh"
        (click)="reloadDueInvoices()"
        [disabled]="pending()"
        [class.rotating]="pending()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </mat-action-row>

    <div style="overflow: auto">
      <table matSort matSortActive="NextInvoiceDate" matSortDirection="asc" #dueInvoicesSort="matSort" mat-table [dataSource]="dueInvoicesSource()" [trackBy]="trackByInvoice">
        <ng-container matColumnDef="code" sticky>
          <th mat-header-cell mat-sort-header="ClientCode" *matHeaderCellDef>Client Code</th>
          <td mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/client-accounts/view', agreement.ClientCode]">{{ agreement.ClientCode }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Client Name</th>
          <td mat-cell *matCellDef="let agreement">{{ clientNames()[agreement.ClientCode] }}</td>
        </ng-container>

        <ng-container matColumnDef="number">
          <th mat-header-cell mat-sort-header="AgreementNumber" *matHeaderCellDef>Agreement&nbsp;#</th>
          <td mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/agreements/view', agreement.AgreementNumber]">{{ agreement.AgreementNumber }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef>Service</th>
          <td mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/agreements/view', agreement.AgreementNumber]">{{ agreement.Title }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="cycle">
          <th mat-header-cell *matHeaderCellDef>Cycle</th>
          <td mat-cell *matCellDef="let agreement">{{ agreement.BillingCycle }}</td>
        </ng-container>

        <ng-container matColumnDef="expiry">
          <th mat-header-cell mat-sort-header="NextInvoiceDate" *matHeaderCellDef>Expiry</th>
          <td mat-cell *matCellDef="let agreement" [class.mat-text-error]="agreement._invoiceIn! < 0">
            {{ agreement.NextInvoiceDate | date: 'dd/MM/y' }}
            @if (agreement._invoiceIn! < 0) {
              <strong> ({{ -agreement._invoiceIn! }} day{{ agreement._invoiceIn! > -2 ? '' : 's' }}) </strong>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let agreement">
            ${{
              (agreement.ServiceAmount || 0) +
                (agreement.HostingAmount || 0) +
                (agreement.SupportMaintenanceAmount || 0) | number
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let agreement">
            @if (authService.isAdmin()) {
              <button
                mat-mini-fab
                matTooltip="Invoiced"
                matTooltipPosition="left"
                (click)="updateNextInvoiceDate(agreement)"
              >
                <mat-icon>currency_exchange</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="['code', 'name', 'number', 'service', 'cycle', 'expiry', 'amount', 'actions']"
        ></tr>
        <tr
          mat-row
          *matRowDef="
            let invoices;
            columns: ['code', 'name', 'number', 'service', 'cycle', 'expiry', 'amount', 'actions']
          "
        ></tr>
      </table>
    </div>
  </mat-expansion-panel>

  @if (addons().length) {
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Separate Addons</mat-panel-title>
        <mat-panel-description> invoice in less than 14 days </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-action-row>
        <button mat-mini-fab (click)="reloadDueInvoices()" [disabled]="pending()" [class.rotating]="pending()">
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-action-row>
      <div style="overflow: auto">
        <table matSort matSortActive="NextInvoiceDate" matSortDirection="asc" #addonsSort="matSort" mat-table [dataSource]="addonsSource()" [trackBy]="trackByAddon">
          <ng-container matColumnDef="code" sticky>
            <th mat-header-cell *matHeaderCellDef>Client Code</th>
            <td mat-cell *matCellDef="let addon">
              <a [routerLink]="['/app/client-accounts/view', addon.parent.ClientCode]">{{ addon.parent.ClientCode }}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Client Name</th>
            <td mat-cell *matCellDef="let addon">{{ clientNames()[addon.parent.ClientCode] }}</td>
          </ng-container>
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef>Agreement&nbsp;#</th>
            <td mat-cell *matCellDef="let addon">
              <a [routerLink]="['/app/agreements/view', addon.parent.AgreementNumber]">{{
                addon.parent.AgreementNumber
              }}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="service">
            <th mat-header-cell *matHeaderCellDef>Service</th>
            <td mat-cell *matCellDef="let addon">
              <a [routerLink]="['/app/agreements/view', addon.parent.AgreementNumber]">{{ addon.parent.Title }}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="cycle">
            <th mat-header-cell *matHeaderCellDef>Cycle</th>
            <td mat-cell *matCellDef="let addon">{{ addon.BillingCycle }}</td>
          </ng-container>
          <ng-container matColumnDef="expiry">
            <th mat-header-cell mat-sort-header="NextInvoiceDate" mat-sort-header="NextInvoiceDate" *matHeaderCellDef>Expiry</th>
            <td mat-cell *matCellDef="let addon" [class.mat-text-error]="addon._invoiceIn < 0">
              {{ addon.NextInvoiceDate | date: 'dd/MM/y' }}
              @if (addon._invoiceIn < 0) {
                <strong>({{ -addon._invoiceIn }} day{{ addon._invoiceIn > -2 ? '' : 's' }})</strong>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let addon">${{ addon.InvoiceAmount || 0 }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let addon">
              @if (authService.isAdmin()) {
                <button
                  mat-mini-fab
                  matTooltip="Invoiced"
                  matTooltipPosition="left"
                  (click)="updateNextInvoiceDate(addon.parent, addon)"
                >
                  <mat-icon>currency_exchange</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <tr
            mat-header-row
            *matHeaderRowDef="['code', 'name', 'number', 'service', 'cycle', 'expiry', 'amount', 'actions']"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let addons;
              columns: ['code', 'name', 'number', 'service', 'cycle', 'expiry', 'amount', 'actions']
            "
          ></tr>
        </table>
      </div>
    </mat-expansion-panel>
  }
  @if (milestones().length) {
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Ready to Invoice Milestones</mat-panel-title>
        <mat-panel-description> Milestones eligible for invoicing </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-action-row>
        <button mat-mini-fab (click)="reloadMilestones()" [disabled]="pending()" [class.rotating]="pending()">
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-action-row>

      <div>
        <table matSort matSortActive="DueDate" matSortDirection="asc" #milestonesSort="matSort" mat-table [dataSource]="milestonesSource()" [trackBy]="trackByMilestone" [fixedLayout]="true">
          <ng-container matColumnDef="job_number">
            <th mat-header-cell *matHeaderCellDef>Job Number</th>
            <td mat-cell *matCellDef="let m">
              <a [routerLink]="['/app/products/view', m.JobNumber]"> {{ m.JobNumber }} </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let m">{{ m.Name }}</td>
          </ng-container>

          <ng-container matColumnDef="due_date">
            <th mat-header-cell mat-sort-header="DueDate" *matHeaderCellDef>Due Date</th>
            <td mat-cell *matCellDef="let m">{{ m.DueDate | date: 'dd/MM/y' }}</td>
          </ng-container>

          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let m">${{ m.Value | number: '.0-2' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let m">
              @if (authService.isAdmin()) {
                <button matButton="filled" (click)="invoiceMilestone(m, m.JobNumber)">
                  {{ milestoneStatuses[m.Status] }}
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['job_number', 'name', 'due_date', 'value', 'actions']"></tr>
          <tr mat-row *matRowDef="let m; columns: ['job_number', 'name', 'due_date', 'value', 'actions']"></tr>
        </table>
      </div>
    </mat-expansion-panel>
  }
  @if (purchasedHours().length) {
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Ready to Invoice Purchased Hours</mat-panel-title>
        <mat-panel-description> Purchased hours eligible for invoicing </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-action-row>
        <button mat-mini-fab (click)="reloadPurchasedHours()" [disabled]="pending()" [class.rotating]="pending()">
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-action-row>
      <div>
        <table  matSort matSortActive="DueDate" matSortDirection="asc" #purchasedHoursSort="matSort" mat-table [dataSource]="purchasedHoursSource()" [trackBy]="trackByPurchasedHours" [fixedLayout]="true">
          <ng-container matColumnDef="job_number">
            <th mat-header-cell *matHeaderCellDef>Job Number</th>
            <td mat-cell *matCellDef="let item">
              <a
                [routerLink]="[
                  '/app/' + (item._owner.type === 'agreement' ? 'agreements' : 'products') + '/view',
                  item._owner.id,
                ]"
              >
                {{ item._owner.id }}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let item">{{ item.Notes }}</td>
          </ng-container>
          <ng-container matColumnDef="due_date">
            <th mat-header-cell mat-sort-header="DueDate" *matHeaderCellDef>Due Date</th>
            <td mat-cell *matCellDef="let item">{{ item.DueDate | date: 'dd/MM/y' }}</td>
          </ng-container>
          <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef>Value</th>
            <td mat-cell *matCellDef="let item">${{ item.Value | number: '.0-2' }}</td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let item; let idx = index">
              @if (authService.isAdmin()) {
                <button
                  mat-raised-button
                  matButton="filled"
                  (click)="invoicePurchasedHours(item, item._owner.type, item._owner.id)"
                >
                  {{ milestoneStatuses[item.Status] }}
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['job_number', 'name', 'due_date', 'value', 'actions']"></tr>
          <tr mat-row *matRowDef="let item; columns: ['job_number', 'name', 'due_date', 'value', 'actions']"></tr>
        </table>
      </div>
    </mat-expansion-panel>
  }

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Expiring Agreements</mat-panel-title>
      <mat-panel-description> Agreements expiring within {{ agreementService.expiringWindow }} days </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-action-row>
      <button mat-mini-fab (click)="reloadDueInvoices()" [disabled]="pending()" [class.rotating]="pending()">
        <mat-icon>refresh</mat-icon>
      </button>
    </mat-action-row>

    <div style="overflow: auto">
      <mat-table matSort matSortActive="EndDate" matSortDirection="asc" #expiringAgreementsSort="matSort"  [dataSource]="expiringAgreementsSource()" [trackBy]="trackByExpiring" style="min-width: 850px">
        <ng-container sticky matColumnDef="client_code">
          <mat-header-cell *matHeaderCellDef>Client Code</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/client-accounts/view', agreement.ClientCode]">{{ agreement.ClientCode }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_name">
          <mat-header-cell *matHeaderCellDef>Client Name</mat-header-cell>
          <mat-cell *matCellDef="let agreement"> {{ clientNames()[agreement.ClientCode] }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="agreement_number">
          <mat-header-cell *matHeaderCellDef>Agreement #</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/agreements/view', agreement.AgreementNumber]">{{ agreement.AgreementNumber }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="service">
          <mat-header-cell *matHeaderCellDef>Service</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            <a [routerLink]="['/app/agreements/view', agreement.AgreementNumber]">{{ agreement.Title }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cycle">
          <mat-header-cell *matHeaderCellDef>Cycle</mat-header-cell>
          <mat-cell *matCellDef="let agreement"> {{ agreement.BillingCycle }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expiry">
          <mat-header-cell mat-sort-header="EndDate" *matHeaderCellDef>Expiry</mat-header-cell>
          <mat-cell *matCellDef="let agreement" [class.mat-text-error]="agreement._expiringIn! < 0">
            {{ agreement.EndDate | date: 'dd/MM/y' }}
            @if (agreement._expiringIn! < 0) {
              <strong>({{ -agreement._expiringIn! }} day{{ agreement._expiringIn! > -2 ? '' : 's' }})</strong>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="value">
          <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
          <mat-cell *matCellDef="let agreement"> ${{ agreement.InvoiceAmount | number }} </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="['client_code', 'client_name', 'agreement_number', 'service', 'cycle', 'expiry', 'value']"
        ></mat-header-row>
        <mat-row
          *matRowDef="
            let agreement;
            columns: ['client_code', 'client_name', 'agreement_number', 'service', 'cycle', 'expiry', 'value']
          "
        ></mat-row>
      </mat-table>
    </div>
  </mat-expansion-panel>
</mat-accordion>
